import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import SEOHead from "../../components/feature/SEOHead";
import ProductHero from "./components/ProductHero";
import ProductFeatures from "./components/ProductFeatures";
import PricingSection from "./components/PricingSection";
import IntegrationsSection from "./components/IntegrationsSection";

const SITE_URL = import.meta.env.VITE_SITE_URL ?? "https://trackly.app";

const productJsonLd = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Trackly",
  "description": "Full-access profit tracker for resellers with fee-aware calculations, flip history, performance stats, and platform integrations.",
  "applicationCategory": "FinanceApplication",
  "operatingSystem": "Web",
  "url": `${SITE_URL}/product`,
  "offers": [
    {
      "@type": "Offer",
      "name": "Pro Monthly",
      "price": "9.00",
      "priceCurrency": "USD",
      "description": "Trackly Pro — billed monthly",
    },
    {
      "@type": "Offer",
      "name": "Pro Yearly",
      "price": "100.00",
      "priceCurrency": "USD",
      "description": "Trackly Pro — billed annually, 2 months free (save $8)",
    },
    {
      "@type": "Offer",
      "name": "Pro Lifetime",
      "price": "200.00",
      "priceCurrency": "USD",
      "description": "Trackly Pro — one-time lifetime access",
    },
  ],
};

export default function Product() {
  return (
    <div className="bg-[#050505] min-h-screen">
      <SEOHead
        title="Trackly Pro — Pricing, Features & Platform Integrations | Profit Tracker"
        description="Compare Trackly Free vs Pro. Get full access to fee-aware profit calculations, flip history, performance stats, and more — starting at $9/mo or $200 lifetime."
        keywords="trackly pro, reseller profit tracker pricing, flip analytics, sports card tracker subscription, eBay fee calculator"
        canonical={`${SITE_URL}/product`}
        ogTitle="Trackly Pro — Everything a Serious Reseller Needs"
        ogDescription="Fee-aware calculations, flip history, performance stats, platform integrations. Trackly Pro starts at $9/mo."
        jsonLd={productJsonLd}
      />
      <Navbar />
      <main>
        <ProductHero />
        <ProductFeatures />
        <IntegrationsSection />
        <PricingSection />
      </main>
      <Footer />
    </div>
  );
}
